module.exports = __webpack_public_path__ + "static/media/GLS5.e217d1d5.jpg";